export const HIGHER_IS_BETTER = "higher-is-better";
export const LOWER_IS_BETTER = "lower-is-better";

const expenseKeywords = [
  "other expense",
  "ad spend",
  "software",
  "sales & marketing",
  "cogs",
  "cost",
  "expense",
  "spend",
  "opex",
  "fee",
  "commission",
  "promotion",
  "marketing",
  "labor",
  "payroll",
  "freight",
  "fulfillment",
  "tax",
  "interest",
  "depreciation",
  "amortization",
  "rent",
  "general and admin",
  "beroas",
];

const incomeKeywords = [
  "net other income/expense",
  "other income",
  "revenue",
  "income",
  "profit",
  "margin",
  "contribution",
  "ebitda",
  "gross",
  "yoy growth",
  "mer",
];

// Explicit mixed-name exceptions run before expense matches; expense matches then beat income matches.
export const getProfitAndLossVarianceDirection = (tableKey, metricName) => {
  const name = String(metricName || "").toLowerCase();
  if (
    name.includes("net other income/expense") ||
    name.includes("net income") ||
    name.includes("net profit")
  ) {
    return HIGHER_IS_BETTER;
  }
  if (expenseKeywords.some((keyword) => name.includes(keyword))) return LOWER_IS_BETTER;
  if (incomeKeywords.some((keyword) => name.includes(keyword))) return HIGHER_IS_BETTER;

  if (tableKey === "total-cost-of-goods-sold" || tableKey === "total-operating-expenses") {
    return LOWER_IS_BETTER;
  }
  return HIGHER_IS_BETTER;
};

export const isVarianceImprovement = (numericValue, direction) => {
  if (Number.isNaN(numericValue)) return false;
  return direction === LOWER_IS_BETTER ? numericValue <= 0 : numericValue >= 0;
};
